module.exports = "https://www.gc-qa.gnp.com.mx/68862f7ca683b3ba92ace67df644026f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/bg-video-4.png
// module id = 952
// module chunks = 0 1